/**
 * The interfaceOf returns a boolean indicating if the model matches an interface
 *
 * ```ts
 * const animal: Bird | Fish = {
 *  // ...
 * };
 *
 * if (interfaceOf<Bird>(animal, "fly")) {
 *  // its a Bird
 * } else {
 *  // its a Fish
 * }
 * ```
 * @param model object to do the type check on
 * @param property a unique property that exist only in TModel
 *
 */
export function interfaceOf<TModel>(model: any, property: keyof TModel): model is TModel {
	return model && property in model;
}
